import React from 'react';
import { Navigate } from 'react-router-dom';
// Layout Types
import { PrivateLayout } from '../layouts';
import { AddTask } from '@components/ToDo/AddTask';
import { Login } from '@components/Login/Login';
import ResetPassword from '@components/ResetPassword/ResetPassword';
import ChangePasswordForm from '@components/ResetPassword/ChangePasswordForm';
import Setup from '../pages/Setup/Setup';
import Consent from '../pages/Consent/Consent';

// Route Views
const AuthRoutes = [
    {
        path: '/',
        exact: true,
        layout: PrivateLayout,
        component: () => <Navigate to="/dashboard" />,
    },
    {
        path: '/login',
        exact: true,
        layout: PrivateLayout,
        component: Login,
    }
    ,
    {
        path: '/reset-password',
        exact: true,
        layout: PrivateLayout,
        component: ResetPassword,
    },
    {
        path: '/change-password',
        exact: true,
        layout: PrivateLayout,
        component: ChangePasswordForm,
    },
    {
        path: '/consent',
        exact: true,
        layout: PrivateLayout,
        component: Consent,
    },
];

export default AuthRoutes;
